import { TProductCategory, TProductInstance } from '@lib/core/products/types';
import { ApiQueries } from '@lib/core/service/consts';
import { ILocaleText } from '@lib/tools/locale/views/LocaleFragment';

export type TStyleStats = Record<string, { count: number; name: string }>;

export type IProductsResponse = {
  count: number;
  results: TProductInstance[];
  next: string;
  previous: string;
  stats: Record<string, any>;
  featuredProducts?: TProductInstance[];
};

export interface IFetchProductsOptions {
  params: {
    offset?: number;
    limit?: number;
    [ApiQueries.ordering]?: string;
    [ApiQueries.productCategory]?: TProductCategory;
  };
  isPagination?: boolean;
  isJournalCase?: boolean;
  isFirstRequest?: boolean;
  shouldShuffleResponse?: boolean;
}

export type IProductsRequestMeta = {
  arg: IFetchProductsOptions;
};

export enum ThirdPartyConnectModalScenario {
  WISHLIST = 'wishlist',
  LOCATION = 'location',
  RATE5 = 'rate5',
  RATE4 = 'rate4',
}
export interface IThirdPartyNewsletterTexts {
  titleText: ILocaleText;
  descriptionText: string;
  acceptBtnText: ILocaleText;
  rejectBtnText: ILocaleText;
}

export type ThirdPartyConnectModalShown = {
  [key in ThirdPartyConnectModalScenario]: boolean;
};

export type TWidgetIframeParentDimension = 'mobile' | 'tablet' | 'desktop';

export type TProductInteraction = {
  productId: string | null;
  timer: number | null;
  isShow: boolean;
  index: number;
};

export type TSetProductInteraction = Partial<Pick<TProductInteraction, 'productId' | 'timer' | 'index'>> & {
  toggleIsShow?: boolean;
};

export type TAIRecommendationApiResponse = {
  message: {
    role: 'user' | 'assistant';
    content: string;
  };
  trace_id: string;
};

export type TAIRecommendation = {
  promptText: string;
  message: {
    role: 'user' | 'assistant';
    content: {
      test_type: 'TASTE_TEST' | 'SITUATIONAL_TEST' | 'EXPERT_TEST' | 'CONTACT_SUPPORT';
      confidence: number;
      reason: string;
      support_message: string;
    };
  } | null;
};
